import { useRef, useState } from "react"
import { Button, FormGroup, OverlayTrigger, Popover } from "react-bootstrap"
import { CheckLg, ChevronBarExpand, ChevronBarUp, ChevronCompactUp, ChevronUp } from "react-bootstrap-icons"
import { updateTicketPriority } from "../../store/api/CustomerApi";
import { useDispatch } from "react-redux";
import { setErrorDialog } from "../../../store/api/CommonFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleUp } from "@fortawesome/free-solid-svg-icons";

export default function PopSetTicketPriority({ id, defaultPriority, onSet }) {
    const dispatch = useDispatch();
    const [pending, setPending] = useState(false);
    const priorityRef = useRef(defaultPriority ?? 1);
    const handleSubmitPriority = async () => {
        if (pending) {
            return;
        }
        setPending(true);
        const result = await updateTicketPriority(id, priorityRef.current);
        setPending(false);
        if (result.Message || result.message) {
            setErrorDialog(dispatch, result.Message || result.Message, "اولویت تیکت", 5000);
        }
        else if (result.Data) {
            if (typeof onSet === "function") {
                onSet(result);
            }
            setErrorDialog(dispatch, "Success", "اولویت تیکت", 5000);
        }
    }
    const pop = (
        <Popover style={{maxWidth:"250px", width:"200px"}}>
            <Popover.Title className="headerStyle">
                <ChevronBarExpand size={18}/>&nbsp;
                اولویت تیکت
            </Popover.Title>
            <Popover.Content className="bodyStyle">
                <FormGroup>
                    <select className="form-control" defaultValue={defaultPriority ?? 1} onChange={e => priorityRef.current = e.target.value}>
                        <option value={1}>پایین</option>
                        <option value={2}>عادی</option>
                        <option value={3}>بالا</option>
                        <option value={4}>بسیار مهم</option>
                    </select>
                </FormGroup>
                <Button className="alone-btn mt-1 w-100" variant="info" disabled={pending} onClick={handleSubmitPriority}>
                    ثبت تغییرات</Button>
            </Popover.Content>
        </Popover>
    )
    return (
        <OverlayTrigger trigger="click" overlay={pop}>
            <Button className="group-Btn"><ChevronBarExpand size={18}/> اولویت تیکت</Button>
        </OverlayTrigger>
    )
}